import { NgModule } from '@angular/core';
import {
  PreloadAllModules,
  RouterModule,
  Routes,
  TitleStrategy,
} from '@angular/router';
import { AuthRoutes } from '../../auth/routes/auth.routes';
import { AuthGuard } from '../../auth/guards/auth.guard';
import { CoreRoutes } from '../../core/routes/core.routes';
import { SdPageTitleStrategy } from '../../core/providers/sd-page-title-strategy.provider';
import { DictionaryRoutesEnum } from '../../dictionary/routes/dictionary-routes.enum';
import { ResourceRoutesEnum } from '../../resource/routes/resource-routes.enum';

const routes: Routes = [
  {
    path: 'config-error',
    loadComponent: () =>
      import('./components/public-error.component').then(
        m => m.PublicErrorComponent
      ),
  },
  {
    path: AuthRoutes.root,
    loadChildren: () =>
      import('../../auth/providers/keycloak/keycloak-dynamic-auth.module').then(
        m => m.KeycloakDynamicAuthModule
      ),
  },
  {
    path: CoreRoutes.root,
    loadChildren: () =>
      import('../../core/core.module').then(m => m.CoreModule),
    canActivate: [AuthGuard],
  },
  {
    path: DictionaryRoutesEnum.root,
    loadChildren: () => import('../../dictionary/routes/dictionary.routes'),
  },
  {
    path: ResourceRoutesEnum.root,
    loadChildren: () => import('../../resource/routes/resource.routes'),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'auth/authorize',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, //NoPreloading,
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: TitleStrategy,
      useClass: SdPageTitleStrategy,
    },
  ],
})
export class Es01AppRoutingModule {}
